/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../../../common";
import type {
  ERC721A,
  ERC721AInterface,
} from "../../../../../../../../contracts/submodules/moar-locker/submodules/moar/contracts/erc/ERC721A";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalToCurrentOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ApproveToCaller",
    type: "error",
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721AConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721AConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721A__factory extends ContractFactory {
  constructor(...args: ERC721AConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    name_: PromiseOrValue<string>,
    symbol_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ERC721A> {
    return super.deploy(name_, symbol_, overrides || {}) as Promise<ERC721A>;
  }
  override getDeployTransaction(
    name_: PromiseOrValue<string>,
    symbol_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(name_, symbol_, overrides || {});
  }
  override attach(address: string): ERC721A {
    return super.attach(address) as ERC721A;
  }
  override connect(signer: Signer): ERC721A__factory {
    return super.connect(signer) as ERC721A__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721AInterface {
    return new utils.Interface(_abi) as ERC721AInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721A {
    return new Contract(address, _abi, signerOrProvider) as ERC721A;
  }
}
